import { render, staticRenderFns } from "./activeSummarize.vue?vue&type=template&id=0cc408c5&scoped=true&"
import script from "./activeSummarize.vue?vue&type=script&lang=js&"
export * from "./activeSummarize.vue?vue&type=script&lang=js&"
import style0 from "./activeSummarize.vue?vue&type=style&index=0&id=0cc408c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc408c5",
  null
  
)

export default component.exports